export const set = ({ commit, dispatch }, { paymentType, iban, beneficiaryName, beneficiaryAddress, expirationDates }) => {
  return new Promise((resolve) => {
    let proc = []
    if (paymentType === null || paymentType === undefined || paymentType === '-1') {
      dispatch('empty').then(() => {
        resolve()
      })
    } else {
      commit('SET_PAYMENT_TYPE', paymentType)
      commit('SET_IBAN', iban)
      commit('SET_BENEFICIARY_NAME', beneficiaryName)
      commit('SET_BENEFICIARY_ADDRESS', beneficiaryAddress)
      if (expirationDates) {
        proc.push(dispatch('expirationDates/set', expirationDates))
      }
      Promise.all(proc).then(() => {
        resolve()
      })
    }
  })
}

export const empty = ({ commit, dispatch }) => {
  return new Promise((resolve) => {
    commit('SET_PAYMENT_TYPE', null)
    commit('SET_IBAN', undefined)
    commit('SET_BENEFICIARY_NAME', undefined)
    commit('SET_BENEFICIARY_ADDRESS', undefined)
    dispatch('expirationDates/empty')
    .then(() => {
      resolve()
    })
  })
}
